<template>
  <div class="listmx">
    <van-nav-bar
      :title="'考生明细('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
      right-text="批量阅卷"
      @click-right="plyujuan"
    />
    <van-loading style="text-align: center" type="spinner" size="50px" v-if="loading" color="#1989fa" >加载中...</van-loading>
    <van-list
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-row v-for="(item,index) in list" :key="index" class="mxitem" >

        <van-col span="14">
          <van-checkbox-group v-if="item.ssjj =='Y'" v-model="chekbok" direction="horizontal">
          <van-checkbox   :key="item.ksmxid" :name="item.ksmxid"  shape="square">
            <img  v-if="item.cameraurl != null" :src="item.cameraurl" height="135" width="120"/>
            <img v-if="item.cameraurl==null" src="../../assets/img/head.jpeg" height="135" width="120"/>
          </van-checkbox>
          </van-checkbox-group>
          <p v-if="item.ssjj !='Y'">
            <img v-if="item.cameraurl==null" src="../../assets/img/head.jpeg" height="135" width="120"/>
            <img v-if="item.cameraurl != null" :src="item.cameraurl" height="135" width="120"/>
          </p>
        </van-col>
        <van-col span="9">
          <h4>考生：{{ item.studentname }}</h4>
          <p>试卷总分：{{ paperValue }}</p>
          <p v-html="item.ssjj=='Y'?'交卷状态：<font color=green>已交卷</font>':'交卷状态：<font color=red>未交卷</font>'"></p>
          <p v-html="'已答题：<font color=green>'+(item.ydt==null ||  item.wdt=='' ? '0' : item.ydt)+'</font>'"></p>
          <p v-html="'未答题：<font color=red>'+(item.wdt==null || item.wdt=='' ? '0' : item.wdt)+'</font>'"></p>
          <p v-html="'阅题数：<font color=red>'+(item.yjzts==null || item.yjzts=='' ? '0' : item.yjzts)+'</font>/<font color=green>'+(item.yjs==null || item.yjs=='' ? '0' : item.yjs)+'</font>'"></p>
          <p v-html="'判卷得分：<font color=red>'+(item.scores==null || item.scores=='' ? '0' : item.scores)+'</font>'"></p>
        </van-col>
        <van-col span="24">
          <div
            class="enter"
            @click="panfen(item.paperId,item.ksmxid,item.taskid)" v-if="item.ssjj=='Y'"
          >进入判卷<van-icon name="arrow" />
          </div>
        </van-col>
      </van-row>
    </van-list>
  </div>
</template>
<script>
  import {Notify} from "vant";
  export default {
    components: {
      Notify,
    },
    data() {
      return {
        list: [],
        loadinglist:[],
        chekbok:[],
        ysshow:false,
        paperValue:0,
        ckshow:false,
        loading:true,
        finished: false,
        pattern:/^(0|\+?[1-9][0-9]*)$/,
        // 查询参数
        queryParams:{
          taskid:null,
          ksmxid:null,
        },
        formck:{
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
        },
        formys:{
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
          ystime:null,
        },
      }
    },
    created() {
      this.getjkrw();
    },
    methods: {
      onClickLeft() {
        this.$router.push('/yuejuanlist')
      },
      panfen(paperid,ksmxid,stakid) {
        this.$router.push({ name: 'yuejuanindx', params: { paperId:paperid,ksmxid:ksmxid,taskid:stakid} })
      },
      getisks(kssj,jssj)
      {
        var aData = new Date();
        if(this.$moment(kssj).valueOf()<=this.$moment(aData).valueOf()<this.$moment(jssj).valueOf())
        {
          return 1;
        }
        else
        {
          return 0;
        }

      },
      getjkrw()
      {
        let that = this;
        this.queryParams.taskid = this.$route.params.id
        this.paperValue =  this.$route.params.paperValue
        let data = {params:that.queryParams}
        this.$ajax.get('/teacher/examread/listStudent',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
          for (let i = 0; i < this.list.length; i++) {
            this.loadinglist.push(this.loadinglist.length + 1);
          }
          // 数据全部加载完成
          if (this.loadinglist.length >= this.list.length) {
            this.finished = true;
          }
        }, 1000);
      },
      plyujuan()
      {
        let that =this
        that.loading = true;
        this.$dialog.confirm({
          message: "是否批量对选中考生的客观题阅卷？",
          messageAlign: 'center'
        }).then(() => {
          that.$ajax.get("/teacher/examread/teacherreadpl/"+that.chekbok).then(function (res) {
            if (res.code == 200) {
              that.getjkrw();
              Notify({ type: 'success', message: res.msg });
            }
            else
            {
              Notify({ type: 'danger', message: res.msg });
            }
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .listmx{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .mxitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/yuejuanmx.vue